define('base/WildcardClass',[
	'jquery',
	'base/MbiHelper',
	'project/MbiConfig'
], function(
	$,
	_,
	mbiConfig
) {
	'use strict';

	// ------------------------------------------------------------------------
	// JQUERY CLASS WILDCARDS
	//
	// https://gist.github.com/benjamminf/96fd5d88a47780e76a57
	// ------------------------------------------------------------------------

	var removeClass = jQuery.fn.removeClass;
	var hasClass    = jQuery.fn.hasClass;

	var wildcardRE = /([a-z0-9\-_]*\*[a-z0-9\-_]*)+/ig;
	var wildcardReplace = '[a-z0-9\\-_]+';

	function wildcardCheck(className) {
		return typeof className == 'string' && className.indexOf('*') > -1;
	}

	jQuery.fn.removeClass = function(className)	{

		if(wildcardCheck(className)) {

			var RE = [];
			var wildcards = [];

			className = className.replace(wildcardRE, function(match) {
				wildcards.push(match);
				return '';
			});

			for(var i = 0; i < wildcards.length; i++) {
				var wildcard = wildcards[i];
				RE.push('(' + wildcard.replace('*', wildcardReplace) + ')');
			}

			RE = new RegExp(RE.join('|'), 'ig');

			this.each(function() {
				this.className = this.className.replace(RE, '').replace(/\s+/g, ' ').trim();
			});

		}

		return removeClass.call(this, className);
	};

	jQuery.fn.hasClass = function(className) {

		if(wildcardCheck(className)) {

			var RE = new RegExp(className.replace('*', wildcardReplace), 'ig');

			var result = false;

			this.each(function() {
				if(RE.test(this.className)) result = true;
			});

			return result;

		} else {
			return hasClass.call(this, className);
		}

	};

	mbiConfig.modules.WildcardClass = {
		'init': 	true,
		'version':	'2.0.0'
	};

});


